import React from 'react';

const UploadedImage = (props) => {
    return (
    <div className="client__avatar">
        <img className="client__avatar--img" src={props.path}/>
    </div>
    )
};

export default UploadedImage;


// WEBPACK FOOTER //
// ./src/_app/react-components/MediaUploader/components/UploadedImage.jsx